import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	selector: "app-book-distributed-barcode",
	templateUrl: "./books-distributed-barcode.component.html",
	styleUrls: ["./books-distributed-barcode.component.css"],
})
export class BooksDistributedBarcodeComponent implements OnInit {
	constructor(private selectService: SchoolselectorService, private reportService: ReportService, private dialogService: DialogService) {}

	report = {
		SchoolID: 0,
		GradeLevelID: 0,
		AcademyID: 0,
		HomeroomID: 0,
		GroupID: 0,
		ActiveStudent: "ALL",
		StartDate: new Date(),
		EndDate: new Date(),
		OrderByID: "NAME",
		ReturnedID: "ALL",
	};

	lstGradeLevel: any = [];
	lstAcademy: any = [];
	lstGroup: any = [];
	lstHomeroom: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	lstActiveStudent = [
		{
			ID: "ALL",
			Desc: "All",
		},
		{
			ID: "ACTIVE",
			Desc: "Active",
		},
		{
			ID: "INACTIVE",
			Desc: "Inactive",
		},
	];

	lstOrderBy = [
		{
			OrderByID: "NAME",
			OrderByDesc: "Student Name",
		},
		{
			OrderByID: "LOAN DATE",
			OrderByDesc: "Date Loaned to Student",
		},
		{
			OrderByID: "ACAD",
			OrderByDesc: "Academy",
		},
		{
			OrderByID: "GRADE",
			OrderByDesc: "Grade",
		},
		{
			OrderByID: "HOMEROOM",
			OrderByDesc: "Homeroom",
		},
	];

	lstReturned = [
		{
			ID: "ALL",
			Desc: "All",
		},
		{
			ID: "YES",
			Desc: "Yes",
		},
		{
			ID: "NO",
			Desc: "No",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 437;
	subscription: any;

	ngOnInit() {
		// this.AttendanceStatusList();
		// this.EntryTypeList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;

		this.GradeLevelList();
		this.AcademyList();
		this.HomeroomList();
		this.GroupList();
	}

	private GradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.reportService.GradesGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				this.lstGradeLevel.unshift({
					GradeLevelID: 0,
					GradeLevelDesc: "All Grades",
				});

				this.report.GradeLevelID = this.lstGradeLevel[0].GradeLevelID;
			},
			(error) => {}
		);
	}

	private AcademyList() {
		this.report.AcademyID = 0;
		var result = this.reportService.AcademyGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				this.lstAcademy.unshift({
					AcademyID: 0,
					AcademyDesc: "All Academies",
				});

				this.report.AcademyID = this.lstAcademy[0].AcademyID;
			},
			(error) => {}
		);
	}

	private HomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.reportService.HomeroomGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				if (this.lstHomeroom.length == 0) {
					this.lstHomeroom.unshift({
						HomeroomID: 0,
						HomeroomDesc: "All Homerooms",
					});
				}

				this.report.HomeroomID = this.lstHomeroom[0].HomeroomID;
			},
			(error) => {}
		);
	}

	private GroupList() {
		this.report.GroupID = 0;
		var result = this.reportService.GroupGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				this.lstGroup.unshift({
					GroupID: 0,
					GroupName: "All Groups",
				});

				this.report.GroupID = this.lstGroup[0].GroupID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		// if (!this.report.SchoolID) {
		//     this.errorMessage = "Select the School";
		//     return
		// }

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		// @GradeLevelID
		// @ACADEMYID
		// @HOMEROOMID
		// @GROUPID
		// @ActiveStudent
		// @STARTDATE
		// @ENDDATE
		// @ORDERBY
		// @RETURNED

		var reportID = 437;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		var startDate = moment(this.report.StartDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.EndDate).format("MM/DD/YYYY");

		strParam += this.report.GradeLevelID + "|GradeLevelID";
		strParam += "," + this.report.AcademyID + "|ACADEMYID";
		strParam += "," + this.report.HomeroomID + "|HOMEROOMID";
		strParam += "," + this.report.GroupID + "|GROUPID";
		strParam += "," + this.report.ActiveStudent + "|ActiveStudent";
		strParam += "," + startDate + "|STARTDATE";
		strParam += "," + endDate + "|ENDDATE";
		strParam += "," + this.report.OrderByID + "|ORDERBY";
		strParam += "," + this.report.ReturnedID + "|RETURNED";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
